import React from "react";
import "../css/Styles.css";

function Footer() {
    return (
        <div>
            <footer class="footer">
                <p class="text-center">&copy; Copyright Matt Autrey</p>
            </footer>
        </div>
    )
}

export default Footer;